<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>CIERRE DE PROVISIONES</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listadoP" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="1000" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title center>
                            <font color="green"> Para Cerrar por Control de Gestión</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <td :class="colorestado(item)">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small class="mr-2" @click="editar(item, 'P')">
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
            <!-- <v-data-table dense :headers="headers" :items="listadoE" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title center>
                            <font color="green"> En Proceso de Ejecución</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mr-2" @click="editar(item, 'E')">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                </template>
            </v-data-table> -->
            <Editar :visible="showEditar" :codgral="editedItem.codgral" :codoc="editedItem.codoc"
                @close="showEditar = false">
            </Editar>

        </v-app>
    </div>
</template>


<script>
import axios from "../../axios-auth";
import Editar from "../Lanzamiento/Cierre.vue";
import moment from "moment";

export default {
    components: { Editar },
    data: (vm) => ({
        usuario: "",
        editedItem: {
            fact: "",
            codgral: "",
            empresa: "",
            codoc: "",
            responsable: "",
        },
        editedIndex: -1,
        listadoP: [],
        listadoE: [],
        showEditar: false,
        loadtable: false,
        headers: [
            { text: "N° de Cliente", value: "codgral", sortable: false },
            { text: "Nombre Empresa", value: "empresa", sortable: false },
            { text: "N° de Orden de Compra", value: "codoc", sortable: false },
            { text: "Provisión", value: "provision", sortable: false },
            { text: "Referente Proyecto", value: "responsable", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                //this.usuario = this.$store.state.nombre.toString().trim();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        colorestado(item) {
            if (item.producto == null || item.fechapendiente == '') {
                return "red";
            }
        },
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            let self = this;
            axios
                .get("/Lanzamiento/Listadocierre?", {

                })
                .then((response) => {
                    this.listadoP = response.data;
                    // response.data.forEach(element => {
                    //     if (element.estado == "P") {
                    //         self.listadoP.push(element);
                    //     }
                    //     if (element.estado == "E") {
                    //         self.listadoE.push(element);
                    //     }
                    // });
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listadoP = [];
                    //self.listadoE = [];
                    console.log(error);
                });
        },

        editar(item, flag) {
            //if (flag == "P") {
            this.editedIndex = this.listadoP.indexOf(item);
            // }
            // if (flag == "E") {
            //     this.editedIndex = this.listadoE.indexOf(item);
            // }
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        vaciarModels() {
            this.listadoP = [];
            this.listadoE = [];

        },
    },
};
</script>